import { formatDate, MOMENT_FORMATS, toMoment } from '../../utils/dateFormat';

/** createdAt / sentAt on portal items or FCM data payloads. */
export const pickNotificationCreatedAt = (source = {}) => {
  const nested = source?.data && typeof source.data === 'object' ? source.data : {};

  return (
    source.createdAt ??
    source.created_at ??
    source.sentAt ??
    source.sent_at ??
    nested.createdAt ??
    nested.created_at ??
    nested.sentAt ??
    nested.sent_at ??
    null
  );
};

/** Compact timestamp for list rows and toasts (12-hour clock). */
export const formatNotificationTime = (value) => {
  if (!value) {
    return '';
  }

  const date = toMoment(value);
  if (!date) {
    return String(value);
  }

  const now = toMoment(new Date());
  if (date.isSame(now, 'day')) {
    return formatDate(date, MOMENT_FORMATS.TIME) || '';
  }

  const withYear = !date.isSame(now, 'year');
  return (
    formatDate(
      date,
      withYear
        ? `${MOMENT_FORMATS.DATE_SHORT}, YYYY ${MOMENT_FORMATS.TIME}`
        : `${MOMENT_FORMATS.DATE_SHORT} ${MOMENT_FORMATS.TIME}`,
    ) || ''
  );
};

/** In-app notifications list: empty when the API omits a timestamp. */
export const formatInboxTimeLabel = (source) => {
  const createdAt = pickNotificationCreatedAt(source);
  return createdAt ? formatNotificationTime(createdAt) : '';
};

/** Push / OS notifications: fall back to receive time when payload has no timestamp. */
export const formatPushNotificationTimeLabel = (source = {}) => {
  const createdAt = pickNotificationCreatedAt(source);
  return formatNotificationTime(createdAt ?? new Date());
};

export const joinNotificationBodyAndTime = (body, timeLabel) => {
  const message = String(body ?? '').trim();
  const time = String(timeLabel ?? '').trim();
  if (message && time) {
    return `${message} · ${time}`;
  }
  return message || time || '';
};
